import { BaseContainerModel } from '../base-container.model';
import { bl_mrp_job_order_hdr_RowInterface, bl_mrp_pi_worklog_Rowclass, bl_mrp_process_instance_hdr_RowInterface } from '../../dbschema';

export class MrpLinkedProcessInstanceWorklogContainerModel extends BaseContainerModel {
  bl_mrp_pi_worklog: bl_mrp_pi_worklog_Rowclass = new bl_mrp_pi_worklog_Rowclass();
  bl_mrp_process_instance_hdrs: bl_mrp_process_instance_hdr_RowInterface[] = [];
  bl_mrp_job_order_hdrs: bl_mrp_job_order_hdr_RowInterface[] = [];
}
